/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contacts_PrimaryInputs */

const cs_contacts_primary = /** @type {(inputs: Contacts_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hlavní`)
};

const en_contacts_primary = /** @type {(inputs: Contacts_PrimaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primary`)
};

/**
* | output |
* | --- |
* | "Primary" |
*
* @param {Contacts_PrimaryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const contacts_primary = /** @type {((inputs?: Contacts_PrimaryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contacts_PrimaryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contacts_primary(inputs)
	return cs_contacts_primary(inputs)
});